






































import { Component, Vue } from 'vue-property-decorator'
import * as _ from 'lodash'

@Component({
  components: {
    TextLines: require('./TextLines').default
  }
})
export default class DragDrop extends Vue {
  highlight: boolean = false
  trackLinesText: string = ''
  trackCombos: string[][] = []
  activeTab: number = 0

  get disabled(): boolean {
    if (this.linksAmount === 0) return true

    if (this.activeTab === 1) {
      if (this.trackCombos.some(x => !x[0] || !x[1])) return true
    }

    return false
  }

  get linksAmount(): number {
    if (this.activeTab === 0) {
      return this.trackLinesText.split('\n').filter(x => !!x.trim()).length
    } else if (this.activeTab === 1) {
      return this.trackCombos.length
    } else {
      throw new Error('tab does not exist')
    }
  }

  async search() {
    if (this.disabled) return

    this.$store.commit('storelinks/reset')

    if (this.activeTab === 0) {
      const links = _.uniq(this.trackLinesText.split('\n').filter(x => !!x.trim()))

      this.$store.commit('storelinks/setLinks', links)
    } else if (this.activeTab === 1) {
      this.$store.commit('storelinks/setCombos', this.trackCombos) // TODO: dedupe
    }

    await this.$router.push({
      name: 'store links results'
    })
  }

  onDragdrop(e: DragEvent) {
    e.stopPropagation()
    e.preventDefault()
    this.highlight = false

    if (e.dataTransfer) {
      const text = e.dataTransfer.getData('text/plain')

      this.trackLinesText += '\n' + text

      this.trackLinesText = this.trackLinesText.trim()
    }
  }

  onDragEnter() {
    this.highlight = true
  }

  onDragLeave() {
    this.highlight = false
  }

  created() {
    if (this.$store.state.storelinks.links.length > 0) {
      this.trackLinesText = this.$store.state.storelinks.links.join('\n')
    }

    if (this.$store.state.storelinks.combos.length > 0) {
      this.trackCombos = this.$store.state.storelinks.combos
    }

    if (this.$route.query.activeTab) {
      this.activeTab = parseInt(this.$route.query.activeTab as string)
    }
  }
}
